import React, { useContext, useState } from 'react';
import ItemGroup from './ItemGroup';
import { Card, Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import NoDataLayer from '../../../../../Common/NoDataLayer';
import ChartLine from './ChartLine';
import HEADER_TOOLBAR from '../HEADER_TOOLBAR';
import SidePanelAddConsolidation from '../../BoardElementTypeBox/SidePanelAddConsolidation';
import { ActionButton, Toggle, TooltipHost } from '@fluentui/react';
import { enum__BUTTONKEYS_KPI } from '../../../../../../common/Dictionaries';
import { _checkSecurityUser } from '../../../../../../common/Helpers/HLP_Security';
import MainAppContext from '../../../../../../MainAppContext';
import { __OBJECT_STRUCTURE_GetList } from '../../../../../../common/ObjectStructures/Trasnversal';
import { getLocalStorageValue, isNullUndefined, isNullUndefinedOrEmpty, setLocalStorageValue } from '../../../../../../common/Helpers';
import { useSetInicialValues } from '../../../../../../hooks/component/sKPI/useOfConsolidatedGroupConsolidatedChart';

function SG3KPI_CONSOLIDATE_MONTH(props) {
    const { t } = useTranslation();
    const contextSite = useContext(MainAppContext);

    const { 
		inputParam_ReportHeaderMode = false,
        inputParam_HasPageElementId = false,
        inputParam_BoardId = null,
        inputParam_ElementId = null,
        inputParam_ComponentContent = null,
        inputParam_ComponentConfig = null,
        inputParam_TwoColumnsDisplay = false,
        inputParam_BoardStructure = null,
        inputParam_Container = null
    } = props;
    
    const [isAddConsolidationPanelOpen, setIsAddConsolidationPanelOpen] = useState(false);
    const [selectedElementToPanel, setSelectedElementToPanel] = useState(null);
    const [consolidatedGroupDataSeries, setConsolidatedGroupDataSeries] = useState(JSON.parse(JSON.stringify(__OBJECT_STRUCTURE_GetList(999999, null))))
    const [lastPeriod, setLastPeriod] = useState(!isNullUndefinedOrEmpty(getLocalStorageValue('PARAM_COOKIE_CONSOLIDATED_MONTH_LAST_MONTH_SEARCH')) ? (getLocalStorageValue('PARAM_COOKIE_CONSOLIDATED_MONTH_LAST_MONTH_SEARCH') === 1 ) : true );

    const [chartConfig, setChartConfig] = useState(null);
	useSetInicialValues(chartConfig, setChartConfig);

    const setterSelectedElementToPanel = (_selectedElement) => {
        setSelectedElementToPanel(_selectedElement);
        setConsolidatedGroupDataSeries(__OBJECT_STRUCTURE_GetList(999999, null))
    }

    const onChangeLastPeriod = (e, checked) => {
        setLocalStorageValue('PARAM_COOKIE_CONSOLIDATED_MONTH_LAST_MONTH_SEARCH', checked === true ? "1" : "0")
        setLastPeriod(checked);
    };

    const [consolidatedGroupChart, setConsolidatedGroupChart] = useState(inputParam_ComponentContent !== null ? inputParam_ComponentContent.items.map(item => ({
        name: item.name,
		l_vals: item.l_vals
    })) : []);
    
    return (
            <div className="col-12 listWithActions h-100">
                <Card className='h-100'>
                    {
                    inputParam_ReportHeaderMode ?
                        <Card.Body className='p-0 m-0 text-start rounded-top' style={{fontSize: "13px", fontWeight: "bolder", backgroundColor: "#e3e6f3", color: "darkblue"}}>
                            <TooltipHost content={inputParam_ComponentContent !== null && inputParam_ComponentContent.boardComponentTitle !== null ? inputParam_ComponentContent.boardComponentTitle : t('data-lang-lbl-chart')}>
                                <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                    {
                                        !isNullUndefinedOrEmpty(inputParam_ComponentConfig.htmlTitle) &&
                                        <b>{inputParam_ComponentConfig.htmlTitle.indexOf('data-lang-') ? t(inputParam_ComponentConfig.htmlTitle) :inputParam_ComponentConfig.htmlTitle}</b>
                                    }
                                    {
                                        isNullUndefinedOrEmpty(inputParam_ComponentConfig.htmlTitle) &&
                                        <b>{ inputParam_ComponentContent !== null && inputParam_ComponentContent.boardComponentTitle !== null ? (inputParam_ComponentContent.boardComponentTitle.indexOf('data-lang-') ? t(inputParam_ComponentContent.boardComponentTitle) : inputParam_ComponentContent.boardComponentTitle) : t('data-lang-lbl-chart')}</b>
                                    }
                                </div>
                            </TooltipHost>
                        </Card.Body> :
                        <Card.Header className="card-header-compact">
                            <Card.Title className="d-flex justify-content-between">
                                <b>{ inputParam_ComponentConfig.htmlTitle !== null ? inputParam_ComponentConfig.htmlTitle : (inputParam_ComponentContent !== null && inputParam_ComponentContent.boardComponentTitle) ?? t('data-lang-boxname-consolidatedgroups')}</b>
                                <div className='toolbar d-flex'>
                                    <HEADER_TOOLBAR
                                        inputParam_BoardStructure={inputParam_BoardStructure}
                                        inputParam_Container={inputParam_Container}
                                    />
                                    <Toggle
                                        label={ t('data-lang-lbl-lastmonth2') }
                                        checked={ !isNullUndefined(lastPeriod) ? lastPeriod : true }
                                        onChange={ onChangeLastPeriod }
                                        role="checkbox"
                                        onText={ t('data-lang-btn-yes') }
                                        offText={ t('data-lang-btn-no') }
                                        styles={ {root:{paddingTop: "12px", float: "right", display: "flex"}, label: {marginRight : "10px", padding: "0px, 0px"}} }
                                    />
                                    {
                                        contextSite.securityProps.isSAdmin &&
                                        <ActionButton
                                            key={enum__BUTTONKEYS_KPI.ADD_BOARD_CONSOLIDATION_GROUP}
                                            text={t('data-lang-btn-add')}
                                            iconProps={{ iconName: 'Add' }}
                                            onClick={() => setIsAddConsolidationPanelOpen(!isAddConsolidationPanelOpen)}
                                        />
                                    }
                                </div>
                            </Card.Title>
                        </Card.Header>
                    }
                    <Card.Body className='px-0 pt-1'>
                        {lastPeriod === true && <Row className='px-2'><Col><b>{t('data-lang-lbl-lastmonthresults')}</b></Col></Row>}
                        {
                            //objBoardScopeValues && objBoardScopeValues.length > 0 &&
                            inputParam_ComponentContent && inputParam_ComponentContent.items.length > 0 &&
                            <Row>
                                {
                                    inputParam_TwoColumnsDisplay &&
                                    <Col className='pe-0'>
                                        <Row className='px-3'>
                                            {
                                                //objBoardScopeValues && objBoardScopeValues.map((item, index) => 
                                                inputParam_ComponentContent && inputParam_ComponentContent.items.map((item, index) => 
                                                    <div key={index}>
                                                        <Row className='p-0'>
                                                            <Col className='mx-0 pb-1 px-1 mx-auto'>
                                                                <ItemGroup 
                                                                    inputParam_Key={ index }
                                                                    inputParam_Object={item}
                                                                    inputParam_ElementId={inputParam_ElementId}
                                                                    inputParam_HasPageElementId={inputParam_HasPageElementId}
                                                                    inputParam_ConsolidatedGroupDataSeries={consolidatedGroupDataSeries}
                                                                    inputParam_SetConsolidatedGroupDataSeries={setConsolidatedGroupDataSeries}
                                                                    inputParam_SetterSelectedElementToPanel={setterSelectedElementToPanel}
                                                                />
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                )
                                            }
                                        </Row>
                                    </Col>
                                }
                                {
                                    !inputParam_TwoColumnsDisplay &&
                                    <Col xl={12} className='pe-0'>
                                        <Row className='px-3'>
                                            <div>
                                                <Row className='p-0'>
                                                {
                                                    //objBoardScopeValues && objBoardScopeValues.map((item, index) => 
                                                    inputParam_ComponentContent && inputParam_ComponentContent.items.map((item, index) => 
                                                        <Col key={index} xl={6} className='mx-0 pb-1 px-1 mx-auto'>
                                                            <ItemGroup
                                                                inputParam_Key={ index }
                                                                inputParam_Object={item}
                                                                inputParam_ElementId={inputParam_ElementId}
                                                                inputParam_HasPageElementId={inputParam_HasPageElementId}
                                                                inputParam_ConsolidatedGroupDataSeries={consolidatedGroupDataSeries}
                                                                inputParam_SetConsolidatedGroupDataSeries={setConsolidatedGroupDataSeries}
                                                                inputParam_SetterSelectedElementToPanel={setterSelectedElementToPanel}
                                                                inputParam_LastPeriod={lastPeriod}
                                                            />
                                                        </Col>
                                                    )
                                                }
                                                </Row>
                                            </div>
                                        </Row>
                                    </Col>
                                }
                                <Col className='me-3'>
                                    <Row className='px-2'><Col><b>{t('data-lang-lbl-lastrollingyearresults')}</b></Col></Row>
                                    <Row className='p-0'>
                                        <Col className='mx-0 pb-2 px-1 mx-auto'>
                                            {
                                                consolidatedGroupChart && chartConfig &&
                                                <ChartLine inputParam_Width={200} inputParam_ChartData={consolidatedGroupChart} inputParam_ChartConfig={chartConfig}/>
                                            }
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>                                
                        }
                        {
                            //objBoardScopeValues && objBoardScopeValues.length === 0 &&
                            inputParam_ComponentContent && inputParam_ComponentContent.items.length === 0 &&
                            <Row>
                                <Col className='mx-1'>
                                    <NoDataLayer display={true} text={t('data-lang-msg-noconsolidatedgroup-configured')} />
                                </Col>
                            </Row>
                        }
                    </Card.Body>
                </Card>
                {
                    isAddConsolidationPanelOpen &&
                    <SidePanelAddConsolidation
                        inputParam_BoardId={inputParam_BoardId}
                        inputParam_IsPanelOpen={isAddConsolidationPanelOpen}
                        inputParam_SetterIsPanelOpen={setIsAddConsolidationPanelOpen}
                    />
                }
            </div>
    );
}

SG3KPI_CONSOLIDATE_MONTH.propTypes = {
};

export default SG3KPI_CONSOLIDATE_MONTH;